import React, { useEffect, useState } from 'react';
import IconNuvem from 'assets/images/robo-sale/icon-cloud.svg';
import IconComputer from 'assets/images/robo-sale/icon-computer.svg';
import IconJustice from 'assets/images/robo-sale/icon-justice.svg';
import IconWeb from 'assets/images/robo-sale/icon-web.svg';
import IconProposta from 'assets/images/robo-sale/icon-proposta.svg';
import IconTime from 'assets/images/robo-sale/icon-time.svg';
import IconSession from 'assets/images/robo-sale/icon-session-2.svg';
import ImgCardRobo from 'assets/images/robo-sale/background-card-robo.svg';
import ImgProposta from 'assets/images/robo-sale/background-cadastrar-proposta.svg';
import ImgLances from 'assets/images/robo-sale/background-lances.svg';
import BgPortais from 'assets/images/robo-sale/background-portais.svg';
import IconComment from 'assets/images/robo-sale/icon-comment.svg';
import IconRobo from 'assets/images/robo-sale/icon-robo.svg';

import { ProportionalSaleTypes } from 'store/modules/proportional_sale_simulation_store/types';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { Container } from './styles';

interface SaleRoboProps {
  dados: any;
}

const SaleRobo = (props: SaleRoboProps) => {
  const { dados } = props;
  const dispatch = useDispatch();
  const [robo, setRobo] = useState<boolean>(false);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  useEffect(() => {
    (async () => {
      if (robo && dados) {
        dispatch({
          type: ProportionalSaleTypes.DADOS_PROPORTIONAL_SALE,
          dados,
          servico: [4],
        });
      }
    })();
  }, [robo]);

  return (
    <Container>
      <div className="container position-one">
        <div className="row mb-4 px-md-4 py-0 py-md-4">
          <div className="col-md-6 mt-5">
            <h1 className="font-weight-bold">Conheça o Robô de</h1>
            <h1 className="font-weight-bold mt-2">Lances do ConLicitação!</h1>
            <h4 className="mt-3">
              Otimize o cadastro de proposta e <br />
              envie lances de forma automática
            </h4>
            <button
              type="button"
              className="btn btn-success"
              onClick={() => {
                const element = document.getElementById('conhecer');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              CONHECER ROBÔ
            </button>
          </div>
          <div className="col-md-6">
            <iframe
              title="Robô de Lances ConLicitação"
              id="video"
              width="100%"
              height="295"
              className="container-video"
              src="https://player.vimeo.com/video/1056061333"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
      <div className="bg-img">
        <div className="container">
          <div id="conhecer" className="row margin session-one mb-5 bg-green py-3 py-md-0 p-md-0">
            <div className="col-md-12">
              <div className="d-flex justify-content-start align-items-center">
                <img className="icon ml-2" src={IconSession} alt="icon-session" />
                <h2 className="text-white font-weight-bold">Como funciona?</h2>
              </div>
              <div className="row text-center mt-5">
                <div className="col-md-6">
                  <div className="card p-3">
                    <div className="icon-text">
                      <img className="icon" src={IconNuvem} alt="icon" />
                      <p className="mb-0 ml-2">
                        <strong>Funciona na nuvem</strong>
                        , sem <br />
                        necessidade de instalação
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mt-4 mt-md-0">
                  <div className="card p-3">
                    <div className="icon-text">
                      <img className="icon" src={IconComputer} alt="icon" />
                      <p className="mb-0">
                        <strong>Totalmente integrado</strong>
                        <br />à plataforma ConLicitação
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row text-center mt-3">
                <div className="col-md-6">
                  <div className="card p-3">
                    <div className="icon-text">
                      <img className="icon" src={IconJustice} alt="icon" />
                      <p className="mb-0 ml-2">
                        Oferece{' '}
                        <strong>
                          modo aberto <br />e modo aberto/fechado
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mt-4 mt-md-0">
                  <div className="card p-3">
                    <div className="icon-text">
                      <img className="icon" src={IconWeb} alt="icon" />
                      <p className="mb-0 ml-2">
                        Permite a
                        <strong>
                          {' '}
                          participação <br />
                          simultânea em vários pregões
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row text-center mt-4">
                <div className="col-md-6">
                  <div className="card p-3">
                    <div className="icon-text">
                      <img className="icon" src={IconProposta} alt="icon" />
                      <p className="mb-0 ml-2">
                        Cadastre as{' '}
                        <strong>
                          suas <br /> propostas{' '}
                        </strong>
                        em um só lugar
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mt-4 mt-md-0">
                  <div className="card p-3">
                    <div className="icon-text">
                      <img className="icon" src={IconTime} alt="icon" />
                      <p className="mb-0 ml-2">
                        Configure o <strong>valor mínimo </strong> dos <br />
                        lances em poucos segundos
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <div className="row mb-5 align-items-center">
          <div className="col-md-7 d-flex justify-content-center">
            <img
              className="icon"
              src={ImgProposta}
              alt="icon"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
          <div className="col-md-5">
            <h4 className="font-weight-bold">
              Dispute licitações com estratégia e inteligência para se tornar mais competitivo
            </h4>
            <p className="mt-3">
              Evite erros operacionais, envie seus lances de forma 100% automática e aumente suas
              chances de vitória
            </p>
          </div>
        </div>
        <div className="row mb-5 align-items-center">
          <div className="col-md-5">
            <h4 className="font-weight-bold">
              O diferencial que você precisa para vencer mais licitações
            </h4>
            <p className="mt-3">
              O nosso Robô de Lances assume o trabalho operacional por você, eliminando ansiedade e
              estresse.
            </p>
          </div>
          <div className="col-md-7 d-flex justify-content-center">
            <img
              className="icon"
              src={ImgLances}
              alt="icon"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>
        <div className="row my-5 align-items-center">
          <div className="col-md-5">
            <p className="mb-0">Tudo isso em uma única ferramenta:</p>
            <h4 className="font-weight-bold">Fácil, simples e intuitiva!</h4>
            <button
              type="button"
              className="btn btn-success mt-4"
              onClick={() => {
                if (!panel?.robo_access) {
                  window.location.href = '/planos';
                } else {
                  setRobo(true);
                }
              }}
            >
              ASSINAR ROBÔ!
            </button>
          </div>
          <div className="col-md-7 d-flex justify-content-center">
            <img
              className="icon"
              src={ImgCardRobo}
              alt="icon"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <img
              className=""
              src={BgPortais}
              alt="Portais"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>
        <div className="row my-5 align-items-center">
          <div className="col-md-6 p-5">
            <h4 className="font-weight-bold mb-3">
              Mais uma solução da empresa líder no mercado de licitações
            </h4>
            <p className="text-secondary">Assine agora e transforme as suas disputas!</p>
          </div>
          <div className="col-md-6 d-flex justify-content-center">
            <div
              className="card text-center p-4"
              style={{ maxWidth: '400px', border: '2px solid #0C8D62', borderRadius: '8px' }}
            >
              <p
                className="text-uppercase fw-bold text-white bg-success p-2"
                style={{ borderRadius: '6px' }}
              >
                Oferta por tempo limitado
              </p>
              <span>
                de{' '}
                <span className="preco-antigo">
                  <del>R$ 349,00</del>
                </span>{' '}
                mensais
              </span>
              <span>
                para
                <span className="preco-novo"> R$ 185,00</span> mensais
              </span>

              <span className="my-4">
                Valor total{' '}
                {dados?.data?.valor_final.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}{' '}
                proporcional ao seu plano atual de assinatura
              </span>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => {
                  if (!panel?.robo_access) {
                    window.location.href = '/planos';
                  } else {
                    setRobo(true);
                  }
                }}
              >
                ASSINAR ROBÔ!
              </button>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-start align-items-center">
          <h2 className="font-weight-bold">Quem utilizou, tem muito a contar</h2>
        </div>
        <div className="row p-4 d-flex">
          <div className="col-md-6 d-flex">
            <div className="card p-4 w-100">
              <img className="icon ml-2" src={IconComment} alt="icon-session" width={40} />
              <p className="mt-3">
                “O fato de fazer tudo numa pagina só, não ter que preencher os descritivos, poder só
                preencher as informações já é um baita alívio na carga de cadastrar uma licitação”
              </p>
              <hr />
              <p className="font-weight-bold text-right mb-0">Biomédika</p>
            </div>
          </div>
          <div className="col-md-6 d-flex">
            <div className="card p-4 w-100">
              <img className="icon ml-2" src={IconComment} alt="icon-session" width={40} />
              <p className="mt-3">
                “Foi muito mais rápido, o que eu achei bacana quando eu coloco o valor unitário, o
                próprio sistema já calcula e isso no portal ele não acontece. E puxar a descrição
                detalhada, em pregões que tem muitos itens isso leva muito tempo.”
              </p>
              <hr />
              <p className="font-weight-bold text-right mb-0">Tecassistiva</p>
            </div>
          </div>
        </div>
        <div className="row p-4 d-flex">
          <div className="col-md-6 d-flex">
            <div className="card p-4 w-100">
              <img className="icon ml-2" src={IconComment} alt="icon-session" width={40} />
              <p className="mt-3">
                “Fico tudo bem mais fácil, mais amplo, aberto pra gente trabalhar, a princípio bem
                tranquilo. Tantos anos de licitação e eu nunca fui chegado em assistente de lance,
                mas agora vocês me convenceram.”
              </p>
              <hr />
              <p className="font-weight-bold text-right mb-0">Informobile</p>
            </div>
          </div>
          <div className="col-md-6 d-flex">
            <div className="card p-4 w-100">
              <img className="icon ml-2" src={IconComment} alt="icon-session" width={40} />
              <p className="mt-3">
                “Justamente isso, estar tudo na mesma plataforma, ali eu já encontro a licitação que
                eu quero e dali eu já consigo configurar o lance sem precisar entrar no portal, hoje
                a gente tem tempo apertado pra tudo.”
              </p>
              <hr />
              <p className="font-weight-bold text-right mb-0">Seleta Saladas</p>
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-start align-items-center">
          <div className="col-md-6">
            <h3 className="mb-0">
              Prepare-se para transformar suas vendas com o Robô de Lances da{' '}
              <strong>melhor plataforma de licitações do país!</strong>
            </h3>
            <button
              type="button"
              className="btn btn-success mt-4"
              onClick={() => {
                if (!panel?.robo_access) {
                  window.location.href = '/planos';
                } else {
                  setRobo(true);
                }
              }}
            >
              VER PREÇO
            </button>
          </div>
          <div className="col-md-6">
            <img
              className="robo"
              src={IconRobo}
              alt="Portais"
              style={{ maxWidth: '70%', height: 'auto' }}
            />
          </div>
        </div>
      </div>
      <div className="bg-dark" />
    </Container>
  );
};

export default SaleRobo;
